export const loadGA = (measurementId) => {
  if (!measurementId) {
    console.warn("GA4 Measurement ID is not provided");
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  // Inject gtag script
  const existing = document.querySelector(
    `script[src^="https://www.googletagmanager.com/gtag/js?id="]`
  );
  if (!existing) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      measurementId
    )}`;
    script.onerror = () => {
      console.error(
        `Failed to load GA4 script for measurement ID: ${measurementId}`
      );
    };
    document.head.appendChild(script);
  }

  // Initialize with debug mode for dev/local environments
  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    debug_mode:
      process.env.REACT_APP_BUILD_ENV === "dev" ||
      process.env.REACT_APP_BUILD_ENV === "local",
    allow_google_signals: true,
    allow_ad_personalization_signals: true,
  });
};
